<script setup>
import IconBase from '@/components/icon/IconBase.vue'
import IconLock from '@/components/icon/IconLock.vue'
import { SITES_UPGRADE_PATH } from '@/Utils/sitesPlanLimits'

// Next to a Domains link when the plan lacks `sites:custom-domain`.
defineProps({
	title: {
		type: String,
		default: 'Custom domains are not included in your current plan',
	},
})
</script>

<template>
	<router-link :to="SITES_UPGRADE_PATH" :title="title" data-testid="sites-plan-lock"
		class="inline-flex items-center gap-1 rounded-full bg-surface-3 px-1.5 py-0.5 align-middle text-[0.65rem] font-medium leading-none text-surface-8 hover:text-white hover:no-underline">
		<icon-base :width="10" :height="10" fill="none" aria-hidden="true"><icon-lock /></icon-base>
		Upgrade
	</router-link>
</template>
